import {useState, useEffect} from 'react';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// @mui material components
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDAvatar from 'components/MDAvatar';

// Material Dashboard 2 React base styles
import breakpoints from 'assets/theme/base/breakpoints';

// Images
import burceMars from 'assets/images/bruce-mars.jpg';
import backgroundImage from 'assets/images/bg-profile.jpeg';
import {Chip, Icon} from '@mui/material';

function Header({user, children}) {
  const [tabsOrientation, setTabsOrientation] = useState('horizontal');
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation('vertical')
        : setTabsOrientation('horizontal');
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener('resize', handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);


  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({
            functions: {rgba, linearGradient},
            palette: {gradients},
          }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6),
            )}, url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: '50%',
          overflow: 'hidden',
        }}
      />
      <Card
        sx={{
          position: 'relative',
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar
              src={user?.avatar || burceMars}
              alt="profile-image"
              size="xl"
              shadow="sm"
            />
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {user?.name
                  ? user?.name
                  : `${user?.firstName} ${user?.lastName}`}
              </MDTypography>
              <MDTypography variant="button" color="text" fontWeight="regular">
                {user?.email}
              </MDTypography>
              {user?.hasOwnProperty('isVerified') && (
                <MDBox gap={1} mt={1} display="flex">
                  <Chip
                    label={user?.status === 'active' ? 'Active' : 'Not Active'}
                    color={user?.status === 'active' ? 'info' : 'error'}
                    variant="filled"
                    size="small"
                    icon={
                      user?.status === 'active' ? (
                        <Icon>check</Icon>
                      ) : (
                        <Icon>close</Icon>
                      )
                    }
                  />
                  <Chip
                    label={user?.isVerified ? 'Verified' : 'Not Verified'}
                    color={user?.isVerified ? 'info' : 'error'}
                    variant="contained"
                    size="small"
                    icon={
                      user?.isVerified ? <Icon>check</Icon> : <Icon>close</Icon>
                    }
                  />
                </MDBox>
              )}
            </MDBox>
          </Grid>
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: '',
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
